import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class AuthApi {
    // defualt method for post request
    static PostDefualtMethod = {
        method: 'POST',
        headers: {
            'Content-Type':'application/json'
        },
        credentials: 'include',        
        mode: 'cors'
    }

    static login (data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/auth/login`, {
            ...AuthApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }

    static logout () {
        return fetch(`${REACT_APP_API_BASE_URL}/api/auth/logout`, {
            ...AuthApi.PostDefualtMethod,
        });
    }

    /**
     * check if user logged in (if response status != 403)
     */
    static isUserLoggedIn () {
        return UserApi.getData();
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.js